import React from "react";
import Testata from "../../components/Testata/Testata";
import imgTestata from "../../assets/testate/testata1.jpg";

import imgAzienda1 from "../../assets/azienda/azienda1.jpg";
import imgAzienda2 from "../../assets/azienda/azienda2.jpg";
import imgAzienda3 from "../../assets/azienda/azienda3.jpg";
import Cta from "../../components/Cta/Cta";
import Gallery from "../../components/Gallery/Gallery.jsx";
import GalleryV from "../../components/Gallery/GalleryV.jsx";
import GalleryTestata from "../../components/Gallery/GalleryTestata";

const Azienda = () => {
  return (
    <div> 
      <GalleryTestata
        arrayFoto={[ "L1180320", "L1180318",]}
        titoloGallery="Azienda"
      />

      <div className="pt">
        <div className="container">
          <div className="intro text-center">
            <h2 className="mb0">Azienda</h2>
          </div>
        </div>
      </div>
      <div className="fluid-list">
        <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180308", "L1180192", "L1180137", "L1180141"]} 
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <p>
                Italimpianti s.r.l. nasce nel 2014, dall'unione di due società,
                ognuna delle quali, portando la propria esperienza e competenza
                nelle proprie mansioni, permette oggi a Italimpianti, di
                offrire, come interlocutore unico, servizi di alto profilo nel
                settore di opere civili e industriali, con specializzazione
                nell’impiantistica elettrica e nelle installazioni di impianti
                industriali, anche chiavi in mano.
              </p>
              <p>
                Italimpianti, oggi è in grado di seguire il cliente, dalla
                progettazione, fino alla completa realizzazione di impianti
                elettrici in media e bassa tensione, con tutte le certificazioni
                necessarie ed i test di “messa in opera” delle strutture.
                Italimpianti, ove richiesto, è anche in grado di fornire
                supporto ed esecuzione, delle opere civili di fondazione e
                servizio.
              </p>
            </div>
          </div>
        </div>
        <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180195", "L1180184", "L1180173", "L1180179"]} 
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <p>
                Seguono all’offerta proposta, la progettazione, realizzazione ed
                installazione di quadri elettrici per distribuzione ed
                automazione, nonché, grazie ad una società controllata, servizi
                di cantiere, quali installazione, supervisione e avviamento di
                nuove unità lavorative e produttive, sia in Italia che
                all’estero.
              </p>
              <p>
                Il settore costruzioni di Italimpianti, ha la competenza e
                formazione necessaria all’esecuzione, in tutta Italia, di opere
                che spaziano dal commerciale, al residenziale, dall’industria,
                alle automazioni, fino ad arrivare a seguire progetti di lavori
                a carattere speciale.
              </p>
              <p>
                Italimpianti può fornire molteplici applicazioni di controllo e
                supervisione, identificando la giusta soluzione per ogni
                esigenza, collaborando in stretto rapporto col cliente finale ed
                analizzando le necessità dello stesso.
              </p>
            </div>
          </div>
        </div>
        <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180336", "L1180338", "L1180341", "L1180333"]}
              titoloGallery="Magazzino prodotti"
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <p>
                L’offerta dei servizi di Italimpianti è tra le più complete del
                settore, avvalendosi di personale altamente competente,
                qualificato e sempre in linea con le normative; a questo
                proposito, un ufficio interno, coordina una regolare attività
                formativa, tenuta da personale interno e da docenti esterni.
              </p>
              <p>
                Italimpianti, al fine di aumentare la propria visibilità ed
                essere vicina ai Clienti Internazionali, ha deciso di trasferire
                la propria Sede Legale a Milano, centro italiano direzionale e
                strategico per i futuri business.
              </p>
              <p>
                Altro argomento positivo, al fine di patrimonializzare
                l’Azienda, risulta essere l’aumento del Capitale Sociale
                Aziendale ad Euro 500.000,00 interamente versato e conferito
                direttamente dai Soci; essi hanno messo a disposizione nuova
                finanza esterna ed il conferimento di nuovi strumenti di lavoro.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Cta />
    </div>
  );
};

export default Azienda;
